import { useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import useIsMobile from "../../customHooks/useIsMobile";
import ScrollToTop from "../../features/shared/scrollToTop";
import BottomBar from "../../MobileLayout/BottomBar";
import Footer from "../Footer/Footer";
import NavigationBar from "../Header/Header";
import MobileHeader from "../MobileHeader/MobileHeader";
import ChatWidget from "../../features/support-chat/ChatWidget";
const HomeLayout = () => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const [paneLeft, SetpanLeft] = useState(false);
  const cart = useSelector((state) => state.cart.cartItems);
  const [state, setState] = useState({
    isPaneOpen: false,
  });
  const [userAddress, setUserAddress] = useState(null);
  const hideHeaderAndBottomBar = /^\/authentication\/(login|register)\/?$/i.test(
    location.pathname
  );

  return (
    <div>
      <ScrollToTop />
      {!hideHeaderAndBottomBar && (
        <div style={{ display: "block", "@media print": { display: "none" } }}>
          {isMobile ? (
            <MobileHeader
              userAddress={userAddress}
              setUserAddress={setUserAddress}
              paneLeft={paneLeft}
              SetpanLeft={SetpanLeft}
              cart={cart}
              state={state}
              setState={setState}
            />
          ) : (
            <NavigationBar
              userAddress={userAddress}
              setUserAddress={setUserAddress}
              state={state}
              setState={setState}
              cart={cart}
              paneLeft={paneLeft}
              SetpanLeft={SetpanLeft}
            />
          )}
        </div>
      )}
      <div>
        <Outlet />
      </div>
      <div style={{ display: "block", "@media print": { display: "none" } }}>
        {!isMobile && <Footer />}
        {isMobile && !hideHeaderAndBottomBar && <BottomBar />}
      </div>
      <ChatWidget />
    </div>
  );
};

export default HomeLayout;
